import styled from "@emotion/styled"
import HeroSectionWrapper from "./HeroSectionWrapper"

const HeroScrollSectionContainer = styled(HeroSectionWrapper)``

export default HeroScrollSectionContainer
